// extracted by mini-css-extract-plugin
module.exports = {"timeslot-title":"TimeslotTitle_timeslot-title__1hET1"};